import { NextStep, PreviousStepProps } from "./constants";

export const getPreviousStep = ({
  attemptingRoute,
  onboarding,
  metaByPath,
  questionnaireOrder,
  rootRoute,
}: PreviousStepProps): NextStep => {
  const currentRouteIndex = questionnaireOrder.indexOf(attemptingRoute);

  for (let i = currentRouteIndex - 1; i >= 0; i--) {
    const previousRouteConfig = metaByPath[questionnaireOrder[i]];

    if (
      previousRouteConfig.canRevisit(onboarding) &&
      !previousRouteConfig.excludeFromBack
    ) {
      return { route: questionnaireOrder[i], isExternal: false };
    }
  }

  return { route: rootRoute, isExternal: true };
};
